import { Navigate, useRoutes } from "react-router-dom"

import { useRoleIsReadOnly, MapAdapterBoundingBox } from "@l2r-front/l2r-networks"

import { MapAdapterIncident } from "../../containers/MapAdapterIncident"
import { useIncidentsStateContext } from "../../contexts/IncidentsContext"
import { IncidentAnalysePage } from "../../pages/IncidentAnalyzePage/IncidentAnalyzePage"
import { MobileIncidentDetailsPage } from "../../pages/MobileIncidentDetailsPage"
import { IncidentsFiltersMobilePage } from "../../pages/MobileIncidentsFiltersPage"
import { MobileIncidentsPage } from "../../pages/MobileIncidentsPage"
import { ValidateEventId } from "../../utils/validateEventId"

export const IncidentsMobileRoutes = () => {
    const { selectedIncidentUuid } = useIncidentsStateContext()
    const readOnly = useRoleIsReadOnly()

    const incidentsRoutes = useRoutes([
        {
            path: "/:eventId/details",
            element: <Navigate replace to="../" />,
        },
        {
            path: "/:eventId/analysis/*",
            element: readOnly ? <Navigate replace to={`../${selectedIncidentUuid}`} /> : <IncidentAnalysePage />,
        },
        {
            path: "/:eventId/*",
            element:
                <ValidateEventId>
                    <MapAdapterIncident />
                    <MobileIncidentDetailsPage />
                </ValidateEventId>,
        },
        {
            path: "/filters/*",
            element: <IncidentsFiltersMobilePage />,
        },
        {
            path: "/*",
            element:
                <>
                    <MapAdapterBoundingBox />
                    <MobileIncidentsPage />
                </>,
        },
    ])

    return incidentsRoutes
}